var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-handler"},[_c(_vm.formComponentName,_vm._b({tag:"component",on:{"create":_vm.onCreateUser,"update":_vm.onUpdateUser}},'component',_vm.componentProps,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }